import { Avatar, Button, CardMedia } from "@mui/material";
import { Link } from "react-router-dom";

export default function SigninButton({ onClick, image, title, link, custom=false, sx={} }) {
  if (link == null) {
    return (
      <Button
        onClick={onClick}
        startIcon={<Avatar src={image} />}
        color="secondary"
        size="large"
      >
        {title}
      </Button>
    );
  }
  return (
    <Button
      LinkComponent={Link}
      to={link}
      onClick={onClick}
      startIcon={!custom  ? <Avatar sx={{
        width: 40,
        height: 40,
        borderRadius: "8px",
    }}  src={image} />: <CardMedia component="img" src={image} sx={sx} />} color="secondary" size="large"
    >
      {title}
    </Button>
  );
}
